import type { EndingNode } from '@tales/story-schema';

interface Props {
  node: EndingNode;
  allEndings: { id: string; title: string }[];
  reached: string[];
  path: string[];
  onReplay: () => void;
  onShare: () => void;
  onHome: () => void;
  next?: { title: string; price: number; unlocked: boolean; onPlay: () => void } | undefined;
}

export function EndingCard({ node, allEndings, reached, path, onReplay, onShare, onHome, next }: Props) {
  const index = allEndings.findIndex((e) => e.id === node.endingId) + 1;
  return (
    <div className="ending">
      <div className="kicker">
        Ending {index} of {allEndings.length} · {reached.length}/{allEndings.length} found
      </div>
      <h2>{node.endingTitle}</h2>
      {node.endingText ? <p>{node.endingText}</p> : null}
      <div className="endings-row" aria-hidden>
        {allEndings.map((e) => (
          <span key={e.id} className={e.id === node.endingId ? 'now' : reached.includes(e.id) ? 'found' : ''} />
        ))}
      </div>
      {path.length ? <div className="path">Your path: {path.join(' → ')}</div> : null}
      {next ? (
        <button className="cta" onClick={next.onPlay}>
          {next.unlocked ? `▶ Next episode: ${next.title}` : `🔒 Next episode · ${next.price} credits`}
        </button>
      ) : null}
      <button className={`cta${next ? ' secondary' : ''}`} onClick={onReplay}>
        Play again — find another ending
      </button>
      <button className="cta secondary" onClick={onShare}>
        Share
      </button>
      <button className="cta secondary" onClick={onHome}>
        Back to series
      </button>
    </div>
  );
}
